import { SelectionType } from '../enums/selection-type';
import { StructureType } from '../enums/structure-type';

export class SelectionArguments {
  public id = '';
  public action = SelectionType.None;
  public structureType = StructureType.Undefined;
}
